<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button" (click)="resetRequest()">Chiudi</button>
		</p>
    <div class="col-sm-12 coldx">
      <h4>Invia Notifica di Aggiornamento</h4>
    </div>
    <div class="col-sm-12 coldx">
      <form [formGroup]="inviaNotificaForm" (ngSubmit)="invia()">
        <div class="row">
          <div comboModInput class="col-sm-6" [labelInput]="'Assegnatario'"
            formControlName="nomeAssegnatario" [mandatory] ="true"
            [optionsCombo] ="assegnatariOptions" [labelOption]="'cognomeNome'"
            [objectReference]="nomeAssegnatario"
            (onReturn)="onAssegnatarioSelected($event)">
          </div>
        </div>
        <div class="row">
          <div textAreaInput [(ngModel)]="request.testoNotifica" class="col-sm-12 pl-15" [labelInput]="'Testo Notifica'"
            [mandatory]="true" formControlName="testoNotifica"  maxlength="255">
          </div>
      </div>
      <div class="col-sm-12 pl-15 mt-5">
        <small role="alert">
          <span *ngIf="remainingChars >= 0">
            {{ inviaNotificaForm.controls['testoNotifica'].value?.length || 0 }} / 255 caratteri
          </span>
          <span *ngIf="remainingChars < 0" class="text-danger">
            Hai superato il limite di {{ -remainingChars }} caratteri (max 255).
          </span>
        </small>
      </div>

        <div class="row">
          <p class="mandatory col-sm-12"><em>* Campi obbligatori</em></p>
        </div>
        <div class="row">
          <p class="col-sm-3 col-xs-6">
            <button type="button" class="btn btn-outline-secondary btn-block"
             (click)="resetRequest()">Reset</button>
          </p>
          <p submitButton
            class="col-sm-3 col-xs-6 col-sm-offset-6"
            [labelButton]="'Invia'" [disabled]="!inviaNotificaForm.valid">
        </div>
      </form>
    </div>
	</div>
</div>
